import { render, staticRenderFns } from "./PartnersView.vue?vue&type=template&id=e6221bea&"
import script from "./PartnersView.vue?vue&type=script&lang=js&"
export * from "./PartnersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports